import { COLLECTION_DETAILS_API } from '../../config/constant/apiConstant';
import { COLLECTION_DATA_API } from '../../helpers/api';
import { createListApiRequest } from '../../helpers/apiHelper';
import { collectionItemsActions } from '../../redux/slicers/collectionItemsSlicer';
import { collectionListActions } from '../../redux/slicers/collectionListSlicer';
import { collectionsActions } from '../../redux/slicers/collectionsSlicer';
import { createDeleteApiAction, createGetListAction, createUpdateApiAction } from '../apiGenerator';

export const getCollectionsApiV2 = createListApiRequest({
  url: COLLECTION_DETAILS_API,
  startAction: null,
  successAction: null,
  errorAction: null,
});

export const getCollectionListApi = createGetListAction({
  endpoint: COLLECTION_DETAILS_API,
  actions: collectionListActions,
  defaultSort: 'name',
});

export const getCollectionPageListApi = createGetListAction({
  endpoint: COLLECTION_DETAILS_API,
  actions: collectionsActions,
  setGlobalSidebarFilters: true,
});

export const updateCollectionApi = createUpdateApiAction({
  actions: collectionsActions,
  endpointUrl: COLLECTION_DETAILS_API,
})

export const deleteCollectionAPI = createDeleteApiAction({
  actions: collectionsActions,
  endpointUrl: COLLECTION_DETAILS_API,
  successMessage: 'Deleted',
})

export const getCollectionPageItemsListApi = createGetListAction({
  endpoint: COLLECTION_DATA_API,
  actions: collectionItemsActions,
  setGlobalSidebarFilters: true,
});
